export default __webpack_public_path__ + "static/mica_title_v2-07f8f027703e78ba4c6e63adb756cf8d.svg";